export const environment: any = {
  appName: 'BBMNET Validador de Documento',
  apiBaseUrl: 'https://validadordocumentosapi-nhzmasfena-uc.a.run.app/api/v1/documento',
  firebaseConfig: {
    apiKey: '$(firebaseApiKey)',
    authDomain: '$(firebaseAuthDomain)',
    projectId: '$(firebaseProjectId)',
    storageBucket: '$(firebaseStorageBucket)',
    messagingSenderId: '$(firebaseMessagingSenderId)',
    appId: '$(firebaseAppId)',
    measurementId: '$(firebaseMeasurementId)',
  },
  featureFlags: {
    enableTelemetry: false,
  },
  siteKeyRecaptcha: '6Lehq5YsAAAAAGxt4XhVMZaDAKQegkx36OXJn5JL',
};
